module.exports = __webpack_public_path__ + "static/img/pic_def_bj.2aa65a9c.png";